import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditItemCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        itemCategory: this.props.ItemList ? this.props.ItemList.name : null,
        itemCategoryDescp: this.props.ItemList ? this.props.ItemList.disc : null,

        id: this.props.ItemList ? this.props.ItemList.id : null,
      },
    };
  }
  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "itemCategory") {
      this.setState({
        value: { ...this.state.value, itemCategory: value },
      });
    } else if (name === "itemCategoryDescp") {
      this.setState({
        value: { ...this.state.value, itemCategoryDescp: value },
      });
    }
  };
  submit = () => {
    let data = this.state.value;

    if (data.itemCategory !== "" && data.itemCategoryDescp !== "") {
      this.props.EditItemCategory(this.state.value);

      this.props.closeEditModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        itemCategory: nextProps.ItemList && nextProps.ItemList.name,
        itemCategoryDescp: nextProps.ItemList && nextProps.ItemList.disc,

        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.showitemCategoryEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Item Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="itemCategory">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="itemCategory"
                            onChange={this.onChange}
                            value={this.state.value.itemCategory}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="itemCategoryDescp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="itemCategoryDescp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.itemCategoryDescp}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditItemCategory;
